export enum TrainingCourseAssetType {
    Video = 1,
    File = 2,
    Image = 3,
    Audio = 4,
    Link = 5,
    Pdf = 6,
}

export enum TrainingCourseAssetAttachmentType {
    UploadedFile = 1,
    DirectLink = 2,
}
